/**
 * 학습 분석 데모 페이지 (Mock 버전)
 */

import React from 'react';
import { PresentationChartLineIcon } from '@heroicons/react/24/outline';
import DemoNavigation from '../components/DemoNavigation';

const DemoStudyAnalyticsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-blue-600 text-white py-3 px-4 text-center">
        <p className="text-sm">📢 이것은 데모 페이지입니다. 모든 데이터는 가상 데이터이며, 데모 시연을 위해 주기적으로 업데이트되어 조금씩 변동될 수 있습니다.</p>
      </div>
      <DemoNavigation currentTitle="학습 분석 (데모)" currentIcon={PresentationChartLineIcon} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-gray-500 text-sm font-medium">평균 학습 시간</h3>
            <p className="text-3xl font-bold text-blue-600 mt-2">6.5시간</p>
            <p className="text-sm text-gray-600 mt-1">일일 평균</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-gray-500 text-sm font-medium">출석률</h3>
            <p className="text-3xl font-bold text-green-600 mt-2">92%</p>
            <p className="text-sm text-gray-600 mt-1">이번 달</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-gray-500 text-sm font-medium">평균 성적</h3>
            <p className="text-3xl font-bold text-purple-600 mt-2">85.3점</p>
            <p className="text-sm text-gray-600 mt-1">전 과목 평균</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-gray-500 text-sm font-medium">목표 달성률</h3>
            <p className="text-3xl font-bold text-orange-600 mt-2">73%</p>
            <p className="text-sm text-gray-600 mt-1">설정 목표 기준</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-4">과목별 성취도</h2>
            <div className="space-y-4">
              {[
                { subject: '수학', score: 88, color: 'bg-blue-600' },
                { subject: '영어', score: 92, color: 'bg-green-600' },
                { subject: '국어', score: 78, color: 'bg-purple-600' },
                { subject: '과학', score: 85, color: 'bg-orange-600' },
              ].map((item) => (
                <div key={item.subject}>
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm font-medium">{item.subject}</span>
                    <span className="text-sm font-semibold">{item.score}점</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className={`${item.color} h-2 rounded-full transition-all`}
                      style={{ width: `${item.score}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-4">주간 학습 패턴</h2>
            <div className="space-y-4">
              {[
                { day: '월요일', hours: 7.2 },
                { day: '화요일', hours: 6.5 },
                { day: '수요일', hours: 8.1 },
                { day: '목요일', hours: 5.8 },
                { day: '금요일', hours: 6.9 },
                { day: '토요일', hours: 4.5 },
                { day: '일요일', hours: 3.2 },
              ].map((item) => (
                <div key={item.day}>
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm font-medium">{item.day}</span>
                    <span className="text-sm font-semibold">{item.hours}시간</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-blue-600 h-2 rounded-full transition-all"
                      style={{ width: `${(item.hours / 10) * 100}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-6 text-center text-gray-500 text-sm">
          📢 데모 모드에서는 실제 학습 데이터가 아닌 샘플 데이터가 표시됩니다.
        </div>
      </div>
    </div>
  );
};

export default DemoStudyAnalyticsPage;
